import React, { useState, useRef, useEffect, useImperativeHandle, forwardRef } from 'react';
import { connect } from 'react-redux';
import HttpAPICall from '../../../services/HttpAPICall';
import { INVENTORY_API_BASE_URL_2 } from '../../../services/TapApiUrls';
import { Modal } from 'bootstrap';
import Ax from '../../../components/hoc/Ax';
import Loader from '../../../components/ui/Loader/Loader';
import TapSelect from '../../../components/ui/TapSelect';
import TapIcon from '../../../services/TapIcon';
import { toast } from 'react-toastify';
import uuid from 'react-uuid';

const ChangeItemStatus = forwardRef((props, ref) => {
    const { access_token } = props;
    const modalIdRef = useRef(uuid());
    const modalElemRef = useRef(null);
    const modalInstanceRef = useRef(null);

    const [loading, setLoading] = useState(false);
    const [itemId, setItemId] = useState('');
    const [allStatusList, setAllStatusList] = useState([]);
    const [itemDetail, setItemDetail] = useState(null);
    const [selectedStatus, setSelectedStatus] = useState('');
    const [submitting, setSubmitting] = useState(false);

    useEffect(() => {
        // initialize modal instance when element mounts
        const el = document.getElementById(modalIdRef.current);
        modalElemRef.current = el;
        if (el) {
            modalInstanceRef.current = new Modal(el, { keyboard: false, backdrop: false });
        }
        return () => {
            // cleanup if needed
            modalInstanceRef.current && modalInstanceRef.current.hide();
            modalInstanceRef.current = null;
        };
    }, []);

    // expose imperative method to parent via ref
    useImperativeHandle(ref, () => ({
        changeStatusModalInit: (id,data) => {
            if (!id) return;
            getFormData(id);
          
            if(data){
                setItemDetail(data);
            }
            // show modal after DOM available
            setTimeout(() => {
                modalInstanceRef.current && modalInstanceRef.current.show();
            }, 50);
        }
    }));

    const getFormData = (id) => {
        if (!id) return;
        if (id === itemId) return; // already loaded
        setLoading(true);
        HttpAPICall.withAthorization('GET', INVENTORY_API_BASE_URL_2 + '/item_change_status?source=web&action=form_data', access_token, { item_id: id }, null, (response) => {
            const statusList = response.data && response.data.length > 0
                ? response.data.map(s => ({ value: s.key, label: s.status }))
                : [];
            setAllStatusList(statusList);
           
            setSelectedStatus('');
            setItemId(id);
        }).then(() => setLoading(false));
    };

    const onSelectChange = (selectedOption) => {
        setSelectedStatus(selectedOption ? selectedOption.value : '');
    };

    const submitForm = (e) => {
        e.preventDefault();
        if (!selectedStatus) {
            toast.error('Please select a status', { position: toast.POSITION.TOP_RIGHT });
            return;
        }
        setSubmitting(true);
        const payload = { id: itemId, status: selectedStatus };
        HttpAPICall.withAthorization('PUT', INVENTORY_API_BASE_URL_2 + '/item_change_status?source=web&action=save', access_token, {}, { ...payload }, (response) => {
            toast.success(response.data.msg, { position: toast.POSITION.TOP_RIGHT });
            modalInstanceRef.current && modalInstanceRef.current.hide();
            props.afterChangeStatus && props.afterChangeStatus();
            setSelectedStatus('');
            setItemId('');
            setItemDetail(null);
        }).then(() => setSubmitting(false));
    };

    return (
        <Ax>
            <div className="modal fade" id={modalIdRef.current} tabIndex="-1">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Change Item Status</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            {loading ? <Loader /> : (
                                <form onSubmit={submitForm} id={`${modalIdRef.current}Form`}>
                                    <div className="row my-2">
                                        <label className="col-sm-4 col-form-label require">Item Status</label>
                                        <div className="col-sm-8">
                                            <TapSelect
                                                options={allStatusList}
                                                changeEvent={onSelectChange}
                                                value={allStatusList.find(u => u.value == selectedStatus)}
                                                isClearable={true}
                                                placeholder="Select Item Status"
                                                autoCompelete="off"
                                                required={true}
                                            />
                                        </div>
                                    </div>

                                    <div className="row my-2">
                                        <label className="col-sm-4 col-form-label"></label>
                                        <div className="col-sm-8">
                                            <div>
                                                <TapIcon.FontAwesomeIcon icon={TapIcon.faInfoCircle} />
                                                <span className=' mx-2'>Item is in {itemDetail?.status_text ?? itemDetail?.status ?? 'N/A'} status.</span>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            )}
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal" onClick={() => { setSelectedStatus(''); }}>Cancel</button>
                            <button type="submit" className="btn btn-primary" disabled={submitting || (itemDetail && itemDetail.can_access === false)} form={`${modalIdRef.current}Form`}>Update {submitting ? (<TapIcon.FontAwesomeIcon icon={TapIcon.faSyncAlt} className="fa-spin" />) : ''}</button>
                        </div>
                    </div>
                </div>
            </div>
        </Ax>
    );
});

const mapStateToProps = state => ({ access_token: state.auth.access_token });

export default connect(mapStateToProps, null, null, { forwardRef: true })(ChangeItemStatus);

